import {_get, _post} from "./Axios";

export default class DpjpApi {
    static get() {
        return _get('/masterdata/dpjp')
    }

    static getSchedule() {
        return _get('/masterdata/dpjp/schedule')
    }

    static create(data) {
        return _post('/masterdata/dpjp/create', data)
    }

    static update(data) {
        return _post('/masterdata/dpjp/update', data)
    }

    static delete(id) {
        return _post('/masterdata/dpjp/delete/' + id, {})
    }
}